import { Typography, Card } from 'antd';
import { Trans } from 'react-i18next';
import { FC } from 'react';

import { useAppSelector } from 'hooks';

import { ReactComponent as OpsIcon } from 'assets/icons/ops.svg';

import './index.scss';

export const RejectedMessage: FC<{ isNotFound?: boolean }> = ({ isNotFound }) => {
	const authError = useAppSelector((state) => state.authorization.authError);

	if (authError) return <></>;

	return (
		<Card className="rejectedMessage">
			<OpsIcon />

			<Trans
				i18nKey={isNotFound ? 'notFoundText' : 'rejectedMessageText'}
				components={{
					title: <Typography.Title level={4} />,
					text: <Typography.Text />,
				}}
			/>
		</Card>
	);
};
